/** 分享 / 站内透传的染色 code（阅读器不读，避免 v2 拉章绑死） */
export const LANDING_CODE_QUERY_KEY = 'landing_code';

/** 落地染色归因三参（与 code 无关） */
export const LANDING_DYE_ATTRIBUTION_KEYS = ['track_id', 'ad_id', 'adset_id'] as const;

/** 分享染色链接标记：承接成功后写入，复制打开时全局上报 */
export const LANDING_TIMESTAMP_QUERY_KEY = 'landing_timestamp';

/**
 * 站内跳转需透传的落地相关 query（landing_code + 三参 + landing_timestamp）
 * 不含 promotion_code，避免复制链触发阅读器 v2
 */
export const LANDING_PERSIST_QUERY_KEYS = [
    LANDING_CODE_QUERY_KEY,
    ...LANDING_DYE_ATTRIBUTION_KEYS,
    LANDING_TIMESTAMP_QUERY_KEY,
] as const;

export type TLandingPersistQueryKey = (typeof LANDING_PERSIST_QUERY_KEYS)[number];
